// The organiser's per-kolejka link carries the round's share token (`<roundId>.<nonce>.<mac>`)
// in its own path, not in the round page: a redirect would pin the player to result
// entry, and a rollback to signups would never bring them back. The link page asks
// for the status on every load and shows whichever view the kolejka is in now.
const ROUND_LINK_BASE = '/kolejka';

// Admitting takes a second secret on top of the share token, so nobody turns the
// public link into an admitting one by typing `/kod` after the address they got.
export function roundLinkPath(shareToken: string, admitCode: string | null): string {
  const base = `${ROUND_LINK_BASE}/${shareToken}`;

  return admitCode ? `${base}/kod/${admitCode}` : base;
}

export function isRoundLinkCode(accessCode: string | null, roundId: string | undefined): boolean {
  if (!accessCode || !roundId) {
    return false;
  }

  return accessCode.startsWith(`${roundId}.`);
}

// Links sent before the link page existed point at the round page with the share
// token as `?kod=`. The token no longer admits anyone on its own, so they land on
// the plain link page and get whatever the signup mode grants.
export function legacyRoundLinkPath(accessCode: string | null, roundId: string | undefined): string | null {
  if (!accessCode || !isRoundLinkCode(accessCode, roundId)) {
    return null;
  }

  return roundLinkPath(accessCode, null);
}

export function roundLinkShowsScoring(roundStatus: string): boolean {
  return roundStatus === 'ACTIVE';
}
